module.exports = __webpack_public_path__ + "media/images/office-c23473245d35aac570f12357a9b9a28d.svg";